export function normalizeError(error: unknown): string {
  return error instanceof Error ? error.message : 'Unexpected error';
}

export async function responseErrorMessage(response: Response): Promise<string> {
  const text = await response.text();
  try {
    const parsed = JSON.parse(text) as { error?: string; detail?: string };
    return [parsed.error, parsed.detail].filter(Boolean).join(': ') || response.statusText;
  } catch {
    return text || response.statusText;
  }
}
